"use client";

import AddOpportunity from "../../pages/crm/opportunity/AddOpportunity.jsx";

export default function AddOpportunityScreen() {
  return <AddOpportunity />;
}
